export const REVIEW = {
  DEFAULT_GROUP_MEMBERS_COUNT: 4,
  DEFAULT_PERSONAL_MEMBERS_COUNT: 1,
}
